import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from "../../features/alertSlice";
import { startSpinner, endSpinner } from "../../features/spinnerSlice";
import { requestData } from "../helpers/requestData";
import { updateParticipantFromClientAction } from "../../features/participantSlice";
import LandingPage from "../../actions/landingPage";
import "../../App.css";

const Home = () => {
    const dispatch = useDispatch();
    const alertMessage = useSelector((state) => state.alert.alertMessage);

    let [updateParticipantFromClient, setUpdateParticipantFromClient] = useState();

    let allRequestData = requestData(window);

    let c1Search = getUrlParam('rid', 'Empty');
    let c2Search = getUrlParam('pid', 'Empty');
    let c3Search = getUrlParam('memberId', 'Empty');

    useEffect(() => {
        if (alertMessage === "" && allRequestData.badUrlHitting) {
            dispatch(setMessage({ success: false, message: "We encountered an unexpected issue. Please contact support." }))
        };

    }, [alertMessage, allRequestData.badUrlHitting, dispatch]);
        const [showLandingPage, setShowLandingPage] = useState(false);
        const [redirectURL, setRedirectURL] = useState("");
const [newTabURL, setNewTabURL] = useState("");


    // Call the Create Participant API

    useEffect(() => {
        if (!updateParticipantFromClient && !allRequestData.badUrlHitting) {
            // call action of API
            let allQueryParams = allRequestData.urlQueryString;
            let landingURL = allRequestData.landingURL;
            setUpdateParticipantFromClient(true);

            // Start spinner
            dispatch(startSpinner());
            dispatch(updateParticipantFromClientAction({ allQueryParams, landingURL }))
                .unwrap()
                .then((result) => {
                    dispatch(endSpinner());

                    if (result.type === "MESSAGE") {
                        dispatch(setMessage({ success: result.success, message: result.message }));
                    } else if (result.type === "REDIRECT") {
                        if (result?.isOpenNewTab === true) {
                            setNewTabURL(result?.isNewTabRedirect || "");
                            setRedirectURL(result?.redirectURL || "");
                            setShowLandingPage(true);
                        } else {
                            window.location.href = result.redirectURL;
                        }
                    }

                })
                .catch((error) => {
                    dispatch(endSpinner());
                    dispatch(setMessage({ success: false, message: error.message || "An error occurred" }));
                });
            }
        }, [updateParticipantFromClient, allRequestData.badUrlHitting, allRequestData.urlQueryString, allRequestData.landingURL, dispatch])


 return (
    <>
        {(c1Search.startsWith("SS") ||
          c2Search.startsWith("SS") ||
          c1Search.startsWith("NBL") ||
          c2Search.startsWith("NBL") ||
          c3Search.startsWith("NBL")) ? (
            <div></div>
        ) : (
            // <div className="processing-container error-container">
            //     <div className="loader-spinner"></div>

            //     <h1 className="congratulations-title error-title">
            //         Thank You
            //     </h1>

            //     <h2 className="congratulations-subtitle">
            //         We appreciate your time
            //     </h2>

            //     <p className="congratulations-message">
            //         Unfortunately, you were not a perfect match for this
            //         specific survey. However, your participation is valuable
            //         to us.
            //     </p>

            //     <p className="warning-message">
            //         ⚠️ Please do not refresh or close window
            //     </p>
            // </div>
                 <div className="spinner-container">
                     <div className="loader-spinner"></div>
                     <p className="spinner-text">Please wait...</p>
                 </div>
        )}

        {showLandingPage && (
            <LandingPage
                newTabURL={newTabURL}
                redirectURL={redirectURL}
            />
        )}
    </>
);
}

function getUrlParam(parameter, defaultvalue) {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

function getUrlVars() {
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

export default Home;